import React, {FunctionComponent} from "react";
import {Alert} from "@mui/material";

export const WarningMessage: FunctionComponent<ErrorMessageProps> = props => {
    return <Alert severity="warning" role="warning-message">{props.message}</Alert>;
}

export interface ErrorMessageProps {
    message: string;
}